import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store/index';
import DateAdapter from '@mui/lab/AdapterMoment';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { CookiesProvider } from 'react-cookie';
import Cookies from 'universal-cookie';
import axios from 'axios';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';

const cookies = new Cookies();

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

let urlElements = window.location.href.split('/') 
let url = (urlElements[2])
let apiurl

//if (url === "localhost:3000" || url === "webextank.webquake.com"){
//  window.apiurl = "webextank-api.webquake.com"
  //window.apiurl = "api.phrasix.com"
//}

//console.log(urlElements)
let check = urlElements[3].split('?')
//console.log(check)

// Parameter für den Direkt AUfruf auslesen und in das window Objekt schreiben
if (urlElements.length === 4 && check[0] === "rec") {
  let vid = urlElements[3].split('=')
  //console.log(vid)
  if (vid[1] !== ""){
    if (vid[1] !== ""){
    let hostmail = vid[1].split('&')
    cookies.set('hostmail', hostmail[0]);
    }
    
    if (vid[2] !== ""){
    cookies.set('direktdate', vid[2]);
    } 
    if (vid[2] === "undefined"){
      console.log("Hit")  
      let nodate = "nodate"  
      cookies.set('direktdate', nodate );
    }
   
    
  } 
}





if (url === "localhost:3000") {
  window.apiurl = "webextank-api.webquake.com"
  }
  else {
  axios.get("https://" + url + "/ApiEndpoint").then(res => {
  apiurl = res.data.apiEndpoint
  window.apiurl = apiurl
  })
}


ReactDOM.render(
  <Provider store={store}>
     <CookiesProvider>
        <BrowserRouter basename={baseUrl}>
          <LocalizationProvider dateAdapter={DateAdapter}>
            <App />
          </LocalizationProvider>
        </BrowserRouter>
    </CookiesProvider>
  </Provider>,
  rootElement); 

// Uncomment the line above that imports the registerServiceWorker function
// and the line below to register the generated service worker.
// By default create-react-app includes a service worker to improve the
// performance of the application by caching static assets. This service
// worker can interfere with the Identity UI, so it is
// disabled by default when Identity is being used.
//
//registerServiceWorker();

